export class IFactory {
  public create(type: any, params?: any): any {
    throw Error('Unimplemented');
  }
}
